// Globals
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Models
import { IPaymentMethod } from '@/models/paymentMethod.model';

// Components
import { Table } from '@/ui';

// Helpers
import { getPaymentMethodsColumns } from '../../helpers';

type TPaymentMethodsTableProps = {
  paymentMethods: IPaymentMethod[] | null;
  isLoading: boolean;
};

const PaymentMethodsTable: FC<TPaymentMethodsTableProps> = ({ paymentMethods, isLoading }) => {
  const { t } = useTranslation(['common']);

  const activePaymentMethodsCount = paymentMethods?.filter(({ enabled }) => enabled)?.length ?? 0;

  const columns = useMemo(() => getPaymentMethodsColumns(t, activePaymentMethodsCount), [t, activePaymentMethodsCount]);

  return (
    <Table
      columns={columns}
      rowKey="id"
      dataSource={paymentMethods ?? []}
      loading={isLoading}
      pagination={false}
      virtual
      rowHoverable
    />
  );
};

export default PaymentMethodsTable;
